<template>
  <div>
    <div class="hero derivative-bg">
      <div class="inner">
        <h1>{{$t('derivativesSimulatorPage.text1')}}</h1>
        <h5 class="subtitle">{{$t('derivativesSimulatorPage.text2')}}</h5>
      </div>
    </div>

    <section class="section3">
      <div class="section-inner">
        <div class="article-col2-container">
          <div class="img-col">
            <img src="@/assets/images/derivative-image1.png" alt="" />
          </div>
          <div class="text-col">
            <h2 class="section-title">{{$t('derivativesSimulatorPage.text3')}}</h2>
            <p>
              {{$t('derivativesSimulatorPage.text4')}}
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="section3 dark">
      <div class="section-inner">
        <h2>{{$t('derivativesSimulatorPage.text5')}}</h2>
        <div class="spacer"></div>
        <div class="col4-grid text-left variant">
          <div class="col4-grid-item">
            <div><img src="@/assets/icons/derivative-icon1.svg" alt="" /></div>
            <h5>{{$t('derivativesSimulatorPage.text6')}}</h5>
            <ul class="col-list">
              <li>{{$t('derivativesSimulatorPage.text7')}}</li>
              <li>{{$t('derivativesSimulatorPage.text8')}}</li>
              <li>{{$t('derivativesSimulatorPage.text9')}}</li>
            </ul>
          </div>
          <div class="col4-grid-item">
            <div><img src="@/assets/icons/derivative-icon2.svg" alt="" /></div>
            <h5>{{$t('derivativesSimulatorPage.text10')}}</h5>
            <ul class="col-list">
              <li>{{$t('derivativesSimulatorPage.text11')}}</li>
              <li>{{$t('derivativesSimulatorPage.text12')}}</li>
            </ul>
          </div>
          <div class="col4-grid-item">
            <div><img src="@/assets/icons/derivative-icon3.svg" alt="" /></div>
            <h5>{{$t('derivativesSimulatorPage.text13')}}</h5>
            <ul class="col-list">
              <li>{{$t('derivativesSimulatorPage.text14')}}</li>
              <li>{{$t('derivativesSimulatorPage.text15')}}</li>
              <li>{{$t('derivativesSimulatorPage.text16')}}</li>
              <li>{{$t('derivativesSimulatorPage.text17')}}</li>
            </ul>
          </div>
          <div class="col4-grid-item">
            <div><img src="@/assets/icons/derivative-icon4.svg" alt="" /></div>
            <h5>{{$t('derivativesSimulatorPage.text18')}}</h5>
            <ul class="col-list">
              <li>{{$t('derivativesSimulatorPage.text19')}}</li>
              <li>{{$t('derivativesSimulatorPage.text20')}}</li>
              <li>{{$t('derivativesSimulatorPage.text21')}}</li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <section class="section3">
      <div class="section-inner">
        <h2>{{$t('derivativesSimulatorPage.text22')}}</h2>
        <div class="spacer"></div>
        <div class="col3-grid center">
          <div class="col3-grid-item">
            <div><img class="device-images" src="@/assets/images/derivative-image2.png" alt="" /></div>
            <h5>{{$t('derivativesSimulatorPage.text23')}}</h5>
          </div>
          <div class="col3-grid-item">
            <div><img class="device-images" src="@/assets/images/derivative-image3.png" alt="" /></div>
            <h5>{{$t('derivativesSimulatorPage.text24')}}</h5>
          </div>
          <div class="col3-grid-item">
            <div><img class="device-images" src="@/assets/images/derivative-image4.png" alt="" /></div>
            <h5>{{$t('derivativesSimulatorPage.text25')}}</h5>
          </div>
        </div>
      </div>
    </section>

    <section class="section3 light-gray">
      <div class="section-inner">
        <h2 class="section-title"></h2>
        <p></p>
        <router-link to="contact" class="contact-us"><BtnPrimary text="Contact us" /></router-link>
      </div>
    </section>
  </div>
</template>

<script>
import BtnPrimary from '@/components/BtnPrimary.vue';

export default {
  name: 'DerivativesSimulatorPage',
  components: { BtnPrimary },
  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped></style>
